import type { Quill } from "@vueup/vue-quill";

type SelectionRange = {
  index: number;
  length: number;
};

const SINGLE_WORD_SELECTION_PATTERN = /^[^\s\n\r\t]+$/;

export const normalizeDoubleClickWordSelection = (
  quill: Quill,
  range: SelectionRange
): SelectionRange | null => {
  if (!range || range.length <= 0) return null;

  const trimmed = useTrimmedSelectionRange()(
    range.index,
    range.index + range.length,
    quill
  );

  if (!trimmed) return null;

  const trimmedLength = trimmed.trimmedEnd - trimmed.trimmedStart;
  if (trimmedLength <= 0) return null;

  if (
    trimmed.trimmedStart === range.index &&
    trimmed.trimmedEnd === range.index + range.length
  ) {
    return range;
  }

  if (!SINGLE_WORD_SELECTION_PATTERN.test(trimmed.text)) {
    return range;
  }

  return {
    index: trimmed.trimmedStart,
    length: trimmedLength,
  };
};
